import { useQuery } from "@tanstack/vue-query";
import { computed, unref, type MaybeRef } from "vue";
import { api } from "./api";
import type { TournamentsResponse } from "@xs2event/js-lib/api";

export const useTournaments = (payload?: MaybeRef) => {
  return useQuery<TournamentsResponse, never, TournamentsResponse>({
    queryKey: computed(() => ["tournaments", payload && unref(payload)]),
    queryFn: async () => {
      const response = await api.get("/tournaments", {
        params: { ...unref(payload) },
      });

      return response.data;
    },
    staleTime: 1000 * 60 * 30, //half an hour,
  });
};
